export default __webpack_public_path__ + "static/tour-into-the-picture-5683c6c483b5b137b8e097e876c12ef4.png";